<template>
    <div id="geosearch-container">
        <label for="geosearch-input">
            City Filter
            <b-icon-info-fill v-b-tooltip.hover.focus title="Type the name of a and select from the drop down, then choose a search radius" font-scale="1.5" variant="primary" tabindex="0"></b-icon-info-fill>
        </label>
        <div class="input-group">
            <form autocomplete="off" style="width: 100%;">
                <input type="text" class="form-control" id="geosearch-input" placeholder="" v-bind:value="value" v-on:input="$emit('input', $event.target.value)">
            </form>
            <button type="button" class="close" style="width:40px; margin-left: -40px;" v-on:click="clearSearch()"><span aria-hidden="true">&times;</span></button>
        </div>
    </div>
</template>

<script>
    /* global google */

    export default {
        name: "GeoSearch",
        data() {
            return {
                searchBox: null
            }
        },
        props: ['value'],
        mounted() {
            let defaultBounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(40.2459,-124.5135),
                new google.maps.LatLng(41.3108,-123.5632)
            );

            let input = document.getElementById("geosearch-input");

            this.searchBox = new google.maps.places.Autocomplete(input);

            this.searchBox.setBounds(defaultBounds);
            this.searchBox.setTypes(['(cities)']);
            //this.searchBox.setTypes(['address']);

            this.searchBox.addListener('place_changed', this.placeChanged)
        },
        methods: {
            clearSearch() {
                this.$emit('updateplace', {});
            },
            placeChanged() {
                let place = this.searchBox.getPlace();
                /*
                if(places.length === 0){
                    return;
                }

                let place = places[0];
                */
                if(!place.geometry){
                    return;
                }

                this.$emit('updateplace', place)
            }
        }
    }
</script>

<style scoped>

</style>